module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min-1200x790.bebc29f2.jpg";